import { FeedbackWidgetsStore } from 'store/feedbackWidget/types.ts'

export const initialFeedbackWidgetState: FeedbackWidgetsStore = {
  error: false,
  loading: false,
  widgets: []
}
